// extracted by mini-css-extract-plugin
export var errorIcon = "_om-1";
export var nameLogo = "_om-0";